<template>
  <v-alert v-if="shouldShowAlert" type="warning" prominent text border="left">
    <div class="d-flex align-center">
      <v-icon large class="mr-3">fal fa-exclamation-triangle</v-icon>
      <div class="flex-grow-1">
        <div class="text-h6">{{ $t('shift_required') }}</div>
        <div class="text-body-2">{{ $t('shift_required_message') }}</div>
      </div>
      <v-btn
        color="primary"
        class="ml-3"
        @click="handleClockIn"
      >
        <v-icon left>fal fa-sign-in-alt</v-icon>
        {{ $t('clock_in_now') }}
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'ShiftLockoutAlert',
  props: {
    show: Boolean,
  },
  data: () => ({
    showClockInDialog: false,
  }),
  computed: {
    shouldShowAlert() {
      const activeShift = this.$store.getters['index/activeShift'];
      return this.show && !activeShift;
    },
  },
  methods: {
    handleClockIn() {
      this.$emit('clock-in-requested');
    },
  },
};
</script>
